import { useState } from "react";
import { Tooltip } from "antd";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";

import CopyButton from "../CopyButton";

interface SecretTextProps {
  value?: string | number | null;
  emptyText?: string;
}

// Fixed length so the mask never hints at the real secret length.
const MASK = "••••••••••••";

const SecretText: React.FC<SecretTextProps> = ({
  value,
  emptyText = "Not set",
}) => {
  const [revealed, setRevealed] = useState(false);

  if (value === undefined || value === null || value === "") {
    return <span style={{ color: "#8c8c8c" }}> {emptyText}</span>;
  }

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        maxWidth: "100%",
        gap: 4,
      }}
    >
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          minWidth: 0,
          fontFamily: revealed ? "monospace" : undefined,
          letterSpacing: revealed ? undefined : 1,
        }}
      >
        {revealed ? value : MASK}
      </span>
      <Tooltip title={revealed ? "Hide" : "Reveal"}>
        <span
          role="button"
          onClick={() => setRevealed(!revealed)}
          style={{
            cursor: "pointer",
            color: "#8c8c8c",
            fontSize: 12,
            display: "inline-flex",
            verticalAlign: "middle",
            flexShrink: 0,
          }}
        >
          {revealed ? <EyeInvisibleOutlined /> : <EyeOutlined />}
        </span>
      </Tooltip>
      {revealed && (
        <CopyButton value={value} style={{ marginLeft: 0, flexShrink: 0 }} />
      )}
    </span>
  );
};

export default SecretText;
